export class WorkflowStatusMinRes {
    id!: number;
    name!: string;
    color: string = '#820000';
    description: string = ''

    constructor(id?: number, name?: string, color?: string) {
        if (id !== undefined && name !== undefined) {
            this.id = id;
            this.name = name;
            if (color !== undefined) {
                this.color = color;
            }
        }
    }
}

export class StatusDetailRes extends WorkflowStatusMinRes {
    // TODO: compare with backend

    y: number | null = null;
    x: number | null = null;
    constructor(id?: number, name?: string, color?: string) {
        super(id, name, color);
    }

}

export class StatusCreateReq {
    // TODO: generate in create logic - its only for assigning transitions (not real id in db)
    id!: number;
    workflowId!: number;
    name!: string;
    color!: string;
}

export class StatusUpdatePosReq {
    // TODO: compare with backend
    id!: number
    x!: number
    y!: number
}